import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTwitter, FiInstagram, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-neutral-surface border-t border-neutral-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 bg-primary rounded-xl flex items-center justify-center shadow-soft flex-shrink-0">
                <svg viewBox="0 0 40 40" className="w-5 h-5" fill="none">
                  <circle cx="20" cy="20" r="12" stroke="white" strokeWidth="2.5" />
                  <path d="M14 20 Q20 14 26 20 Q20 26 14 20Z" fill="white" opacity="0.9" />
                  <line x1="20" y1="8" x2="20" y2="4" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
              </div>
              <span className="text-base font-bold text-text-primary leading-tight">
                Pickleball<br />
                <span className="text-primary">Insight Coach</span>
              </span>
            </div>
            <p className="text-text-secondary max-w-xs mb-6">
              Record. Analyze. Improve. The simplest way to get better at pickleball.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl" />
              </a>
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiInstagram} className="text-xl" />
              </a>
              <a href="#" className="text-text-muted hover:text-primary transition-colors">
                <SafeIcon icon={FiFacebook} className="text-xl" />
              </a>
            </div>
          </div>

          {/* App Links */}
          <div>
            <h4 className="font-bold text-text-primary mb-4">App</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-text-secondary hover:text-primary transition-colors">Features</a></li>
              <li><a href="#how-it-works" className="text-text-secondary hover:text-primary transition-colors">How it Works</a></li>
              <li><a href="#" className="text-text-secondary hover:text-primary transition-colors">Pricing</a></li>
              <li><a href="#" className="text-text-secondary hover:text-primary transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-bold text-text-primary mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-text-secondary hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-text-secondary hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="mailto:support@pickleballinsightcoach.com" className="text-text-secondary hover:text-primary transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-divider text-center md:text-left md:flex justify-between items-center">
          <p className="text-text-muted text-sm">
            © {new Date().getFullYear()} Pickleball Insight Coach. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex justify-center gap-4 text-sm text-text-muted flex-wrap">
            <a href="#download-ios" className="hover:text-primary">Download on iOS</a>
            <span>•</span>
            <a href="#download-android" className="hover:text-primary">Download on Android</a>
            <span>•</span>
            <Link to="/privacy" className="hover:text-primary">Privacy</Link>
            <span>•</span>
            <Link to="/terms" className="hover:text-primary">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;